import AppAlertDialog from "@/src/components/custom/alert-dialog";
import { useListener } from "@/src/hooks/useListener";
import { MODAL_EVENTS } from "@/src/lib/constants";
import { useState } from "react";

interface Props {}
const AboutUsModal: React.FC<Props> = ({}) => {
  const [show, setShow] = useState(false);
  useListener(MODAL_EVENTS.ABOUT_US, () => setShow(!show));

  const handleToggle = (state: boolean) => {
    setShow(!show);
  };

  return (
    <AppAlertDialog
      open={show}
      toggle={handleToggle}
      title="About Us"
      content={
        <div className="!text-left">
          {/* <h3 className="font-bold text-lg text-dark-primary">Introduction</h3> */}
          <p className="text-dark-primary">
          Unlock the perfect space or experience with Myblankspace, the ultimate online booking platform that’s transforming how hosts and bookers connect. 

          </p>
          <br />
          <p className="text-dark-primary">
          For hosts, we offer an unrivalled opportunity to showcase your retail spaces for pop-ups, stunning event centres, or extraordinary experiences, all at prices that attract eager guests and maximise your earning potential. 

          </p>
          <br />
          <p className="text-dark-primary">
          For bookers, we deliver a curated selection of unique, affordable options you won’t find anywhere else, wrapped in a secure, easy to navigate platform designed to make your next big idea a reality. 

            
          </p>
          <br />
          <p className="text-dark-primary mt-1">
          Why settle for ordinary when Myblankspace empowers you to list or book with confidence, simplicity, and unbeatable value? Join us today, your perfect match is waiting!
          </p>
        </div>
      }
      className="max-w-[600px]"
      contentClassName="max-h-[500px] overflow-auto"
      type="info"
      actionText="Continue"
    />
  );
};
export default AboutUsModal;
